export class DefaultList<T> {
  total: number;
  list: Array<T>;

  constructor(defaultList: Partial<DefaultList<T>>) {
    this.total = defaultList.total || 0;
    this.list = defaultList.list || [];
  }
}
